import 'flickity/dist/flickity.pkgd'
import axios from 'axios';

jQuery(document).ready(function() {


})
